import BackgroundsEditingContainer from './backgrounds_editing_container';

const BackgroundsEditing = BackgroundsEditingContainer;
export default BackgroundsEditing;
